export interface ShareTarget {
  id: 'whatsapp' | 'telegram' | 'x' | 'facebook';
  label: string;
  href: string;
}

/** Third-party share intents. `text` should not already contain the URL. */
export function shareTargets(url: string, text: string): ShareTarget[] {
  const u = encodeURIComponent(url);
  const t = encodeURIComponent(text);
  return [
    {
      id: 'whatsapp',
      label: 'WhatsApp',
      href: `https://wa.me/?text=${encodeURIComponent(`${text} ${url}`)}`,
    },
    { id: 'telegram', label: 'Telegram', href: `https://t.me/share/url?url=${u}&text=${t}` },
    {
      id: 'x',
      label: 'X',
      href: `https://twitter.com/intent/tweet?text=${t}&url=${u}&hashtags=SGhaze,HazePun`,
    },
    {
      id: 'facebook',
      label: 'Facebook',
      href: `https://www.facebook.com/sharer/sharer.php?u=${u}`,
    },
  ];
}
